import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef } from 'react';

// Source: images/move-right.svg.
export const MoveRightIcon = forwardRef<SVGSVGElement, BaseIconProps>(
  function MoveRightIcon(props, ref) {
    return (
      <BaseIcon
        ref={ref}
        viewBox="0 0 12 12"
        fill="currentColor"
        stroke="none"
        {...props}
      >
        <path d="M1 0C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1L0 11C0 11.2652 0.105357 11.5196 0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12C1.26522 12 1.51957 11.8946 1.70711 11.7071C1.89464 11.5196 2 11.2652 2 11V1C2 0.734784 1.89464 0.48043 1.70711 0.292893C1.51957 0.105357 1.26522 0 1 0V0Z" />
        <path d="M7 5H4V7H7V10L12 6L7 2V5Z" />
      </BaseIcon>
    );
  },
);
